document.querySelectorAll(".Faq__Item").forEach(function (faq) {
    faq.addEventListener("click", function () {
        if (this.getAttribute("aria-expanded") == "false") {
            document.querySelectorAll(".Faq__Item").forEach(function (fq) {
                fq.querySelector(".Faq__AnswerWrapper").style.height = 0;
                fq.setAttribute("aria-expanded", "false");
            });
            this.querySelector(".Faq__AnswerWrapper").style.height = 'auto';
            this.setAttribute("aria-expanded", "true");
        } else {
            this.querySelector(".Faq__AnswerWrapper").style.height = 0;
            this.setAttribute("aria-expanded", "false");
        }
    })
})

document.querySelectorAll(".FaqSummary__Item").forEach(function (faq) {
    faq.addEventListener("click", function () {
        this.parentElement.querySelector(".is-active").classList.remove("is-active");
        this.classList.add("is-active");
    })
})